var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15406_14318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H0V18H8V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15406_14318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0L8 0.5L1.69368 6.79102L1.10676 7.35837C0.297747 8.26332 0.297747 9.73596 1.10676 10.6409L1.69368 11.2082L8 17.5L8.5 18",
    stroke: "#EAEBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9997 17V1L1.41391 7.58579C0.632863 8.36683 0.632863 9.63316 1.41391 10.4142L7.9997 17Z",
    fill: "#F5F5FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleGray);
export default __webpack_public_path__ + "static/media/triangle-gray.7944d18f9fd248bf2db956d4d0d03e8c.svg";
export { ForwardRef as ReactComponent };